import { concat } from "ramda";
import update from "immutability-helper";

// Redux Prefix
const prefix = concat("AMBASSADOR_LEADERBOARD:");

const SET_AMBASSADOR_LEADERBOARD = prefix("SET_AMBASSADOR_LEADERBOARD");
const SET_PARTICIPANTS = prefix("SET_PARTICIPANTS");
const SET_CAMPAIGN_LIST = prefix("SET_CAMPAIGN_LIST");
const SET_SELECTED_CAMPAIGN_ID = prefix("SET_SELECTED_CAMPAIGN_ID");
const SET_TOTAL_PARTICIPANTS = prefix("SET_TOTAL_PARTICIPANTS");
const SET_SEARCH_QUERY = prefix("SET_SEARCH_QUERY");
const SET_PAGE = prefix("SET_PAGE");
const SET_FILTER_CAMPAIGN_ID = prefix("SET_FILTER_CAMPAIGN_ID");
const SET_LOADING = prefix("SET_LOADING");

const INITIAL_STATE = {
  leaderboards: null,
};

// Actions
export const setAmbassadorLeaderboard = (
  id,
  isAdmin,
  hideColumns,
  showBanner,
  subTitleTable,
) => ({
  type: SET_AMBASSADOR_LEADERBOARD,
  payload: {
    id,
    isAdmin,
    hideColumns,
    showBanner,
    subTitleTable,
  },
});

export const setIsLoading = (id, isLoading) => ({
  type: SET_LOADING,
  payload: {
    id,
    isLoading,
  },
});

export const setParticipants = (id, participants) => ({
  type: SET_PARTICIPANTS,
  payload: {
    id,
    participants,
  },
});

export const setCampaignsList = (id, campaignsList) => ({
  type: SET_CAMPAIGN_LIST,
  payload: {
    id,
    campaignsList,
  },
});

export const setSelectedCampaignId = (id, campaignId) => ({
  type: SET_SELECTED_CAMPAIGN_ID,
  payload: {
    id,
    campaignId,
  },
});

export const setTotalParticipants = (id, total) => ({
  type: SET_TOTAL_PARTICIPANTS,
  payload: {
    id,
    total,
  },
});

export const setSearchQuery = (id, query) => ({
  type: SET_SEARCH_QUERY,
  payload: {
    id,
    query,
  },
});

export const setFilterCampaignId = (id, campaignId) => ({
  type: SET_FILTER_CAMPAIGN_ID,
  payload: {
    id,
    campaignId,
  },
});

export const setPage = (id, page) => ({
  type: SET_PAGE,
  payload: {
    id,
    page,
  },
});

// Reducer
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_AMBASSADOR_LEADERBOARD:
      let newLeaderboards = state.leaderboards;
      newLeaderboards = newLeaderboards ? newLeaderboards : {};
      newLeaderboards[action.payload.id] = {
        participants: [],
        campaignsList: [],
        selectedCampaignId: "",
        totalParticipants: 0,
        searchQuery: "",
        hideColumns: action.payload.hideColumns,
        isAdmin: action.payload.isAdmin,
        showBanner: action.payload.showBanner,
        subTitleTable: action.payload.subTitleTable,
        page: 0,
        filterCampaignId: "",
        isLoading: true,
      };
      return {
        ...state,
        leaderboards: newLeaderboards,
      };
    case SET_PARTICIPANTS:
      return update(state, {
        leaderboards: {
          [action.payload.id]: {
            participants: { $set: action.payload.participants },
          },
        },
      });
    case SET_CAMPAIGN_LIST:
      return update(state, {
        leaderboards: {
          [action.payload.id]: {
            campaignsList: { $set: action.payload.campaignsList },
          },
        },
      });
    case SET_SELECTED_CAMPAIGN_ID:
      return update(state, {
        leaderboards: {
          [action.payload.id]: {
            selectedCampaignId: { $set: action.payload.campaignId },
          },
        },
      });
    case SET_TOTAL_PARTICIPANTS:
      return update(state, {
        leaderboards: {
          [action.payload.id]: {
            totalParticipants: { $set: action.payload.total },
          },
        },
      });
    case SET_SEARCH_QUERY:
      return update(state, {
        leaderboards: {
          [action.payload.id]: {
            searchQuery: { $set: action.payload.query },
          },
        },
      });
    case SET_PAGE:
      return update(state, {
        leaderboards: {
          [action.payload.id]: {
            page: { $set: action.payload.page },
          },
        },
      });
    case SET_FILTER_CAMPAIGN_ID:
      return update(state, {
        leaderboards: {
          [action.payload.id]: {
            filterCampaignId: { $set: action.payload.campaignId },
          },
        },
      });
    case SET_LOADING:
      return update(state, {
        leaderboards: {
          [action.payload.id]: {
            isLoading: { $set: action.payload.isLoading },
          },
        },
      });
    default:
      return state;
  }
}
